<div class="sidebar-wrapper">
  <ul class="nav-menu1">
    <li *ngIf="spinner === true" style="text-align: center;">
      <small>Loading ...</small>
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </li>
    <li style="text-align: center;">
      <h4 style="line-height: initial; font-weight: bolder;">BIENVENIDO</h4>
      <!-- <p style="line-height: initial; text-transform: uppercase;">{{userData.name}}</p> -->
    </li>
  </ul>
  <hr>
  <ul class="nav-menu" *ngIf="menuResults">
    <!--   <ng-container *ngFor="let value of menuItems">
        <li routerLinkActive="active" class="{{value.class}} nav-item no-capitalize independent-li" *ngIf="!value.group">
          <a class="nav-link-menu" title="{{ value.tooltip }}" [routerLink]="[value.path]" *ngIf="isIntern(value.scope) === true || !value.scope">
            <i class="material-icons">{{value.icon}}</i>
            <p>{{value.title}}</p>
          </a>
        </li>
    </ng-container> -->


    <!-- <li class="nav-item no-capitalize independent-li">
          <a class="nav-link-menu" title="Soporte" href="mailto:info@demo.mx">
            <i class="material-icons">mail</i>
            <p>Soporte</p>
          </a>
    </li>

    <br> -->
    <mat-accordion class="custom-mat-accordion">
      <ng-container *ngFor="let item of menuResults">
        &nbsp;
        <ng-container *appPermissionModule="{obj: item.module}">
          <mat-expansion-panel *ngIf="item.name" [expanded]="expandActiveLink(item.module)">
            <mat-expansion-panel-header>
              <mat-panel-title>{{item.name}}</mat-panel-title>
            </mat-expansion-panel-header>
            <!--  <ng-container *ngFor="let value of item.values">
              <li routerLinkActive="active" class="{{value.class}} nav-item no-capitalize" *appPermissionModule="{obj: value.module}">
                <a class="nav-link-menu" title="{{ value.tooltip }}" [routerLink]="[value.path]" *ngIf="isIntern(value.scope) === true || !value.scope">
                  <i class="material-icons">{{value.icon}}</i>

                  <ng-container *ngIf="value.title == 'New Contract' || value.title == 'Contact Us'; else elseTemplate">
                    <p>{{value.title}}</p>
                  </ng-container>
                  <ng-template #elseTemplate>
                    <p matBadge="{{value.badge}}" matBadgePosition="after" matBadgeOverlap="false" matBadgeColor="accent">{{value.title}}</p>
                  </ng-template>
                </a>
              </li>
            </ng-container> -->

            <ng-container *ngFor="let value of item.values">
              <li routerLinkActive="active" class="{{value.class}} nav-item no-capitalize"
                *appPermissionModule="{obj: value.module}">
                <a class="nav-link-menu" title="{{ value.tooltip }}" [routerLink]="[value.path]" *ngIf="!value.scope">
                  <i class="material-icons">{{value.icon}}</i>

                  <ng-container *ngIf="value.title == 'New Contract' || value.title == 'Contact Us'; else elseTemplate">
                    <p>{{value.title}}</p>
                  </ng-container>
                  <ng-template #elseTemplate>
                    <p matBadge="{{value.badge}}" matBadgePosition="after" matBadgeOverlap="false"
                      matBadgeColor="accent">{{value.title}}</p>
                  </ng-template>
                </a>
              </li>
            </ng-container>

          </mat-expansion-panel>
        </ng-container>

      </ng-container>
    </mat-accordion>

    <ng-container *ngFor="let value of menuItems">
      <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="{{value.class}} nav-item no-capitalize independent-li" *ngIf="!value.group">
        <a class="nav-link-menu" title="{{ value.tooltip }}" [routerLink]="[value.path]" *ngIf="!value.scope">
          <i class="material-icons">{{value.icon}}</i>
          <p>{{value.title}}</p>
        </a>
      </li>
    </ng-container>

  </ul>
  <hr>
</div>
